import { render, staticRenderFns } from "./SkeletonGameCard.vue?vue&type=template&id=da8ee1b2&scoped=true&"
import script from "./SkeletonGameCard.vue?vue&type=script&lang=js&"
export * from "./SkeletonGameCard.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonGameCard.vue?vue&type=style&index=0&id=da8ee1b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8ee1b2",
  null
  
)

export default component.exports